export default "__VITE_ASSET__593180d4__"